import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const CustomDropdown = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const dropdownitems = props.dropdownitems;
  const listItems = dropdownitems.map((items) => (
    <DropdownItem
      onClick={
        items.innertitle === "Upload Members"
          ? props.handleImportMembers
          : items.innertitle === "Upload Packages"
          ? props.handleImportPackages
          : items.innertitle === "Upload Sales"
          ? props.handleImportSales
          : items.innertitle === "Download Template"
          ? props.handleDownloadTemplate
          : items.innertitle === "Excel"
          ? props.handleExcel
          : items.innertitle === "Excel (All)"
          ? props.handleExcelAll
          : items.innertitle === "Pdf"
          ? () => {
              props.handlepdf(true, true);
            }
          : props.handlepdfAll
      }
    >
      {items.svg && 
        <span>
          <img alt="export to" src={items.svg} className="img-fluid" />
        </span>
      }
      {items.innertitle}
    </DropdownItem>
  ));

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="custom-dropdown">
      <DropdownToggle caret color="transparent">
        {props.maintitle}
      </DropdownToggle>
      <DropdownMenu className="custom-dropdown-block">
        <div className="sub-title">
          {props.subtitle ? props.subtitle : "Export To"}
        </div>
        {listItems}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CustomDropdown;
